
export default {
  props: {
    to: String,
    text: { default: "حفظ", type: String },
    color: { default: "primary", type: String },
  },
};
